export default __webpack_public_path__ + "static/media/brewery_green.a8ef27ae.svg";